<template>
<!-- Main content -->
<section class="content">
  <!-- <div align="center">
    <div class="col-lg-4" v-for="user in Users">
      <div class="col-lg-12">
        <div class="box box-body">
          <p>{{user.Name}}</p>
          <div>
            <div class="with-border col-lg-12">
              <h4>Total Feedbacks</h4>
            </div>
            <div class="col-lg-3">
              <h3>10</h3>
              <p>Breakfast</p>
            </div>
            <div class="col-lg-3">
              <h3>10</h3>
              <p>Lunch</p>
            </div>
            <div class="col-lg-3">
              <h3>10</h3>
              <p>Snacks</p>
            </div>
            <div class="col-lg-3">
              <h3>10</h3>
              <p>Dinner</p>
            </div>
          </div>

          <div>
            <div class="with-border col-lg-12">
              <h4>Average Rating</h4>
            </div>
            <div class="col-lg-3">
              <h3>4.2</h3>
              <p>Breakfast</p>
            </div>
            <div class="col-lg-3">
              <h3>4.3</h3>
              <p>Lunch</p>
            </div>
            <div class="col-lg-3">
              <h3>2.3</h3>
              <p>Snacks</p>
            </div>
            <div class="col-lg-3">
              <h3>4.6</h3>
              <p>Dinner</p>
            </div>
          </div>

          <div>
            <div class="with-border col-lg-12">
              <h4>Negative Feedback</h4>
            </div>
            <div class="col-lg-3">
              <h3>1</h3>
              <p>Breakfast</p>
            </div>
            <div class="col-lg-3">
              <h3>2</h3>
              <p>Lunch</p>
            </div>
            <div class="col-lg-3">
              <h3>0</h3>
              <p>Snacks</p>
            </div>
            <div class="col-lg-3">
              <h3>6</h3>
              <p>Dinner</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- Info boxes -->
  <div class="row">
    <div class="col-lg-3 col-xs-6">
      <!-- small box -->
      <div class="small-box bg-aqua">
        <div class="inner">
          <h3>{{Cars}}</h3>

          <p>Total Cars</p>
        </div>
        <div class="icon">
          <i class="ion ion-bag"></i>
        </div>
        <!-- <a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a> -->
      </div>
    </div>
    <div class="col-lg-3 col-xs-6">
      <!-- small box -->
      <div class="small-box bg-aqua">
        <div class="inner">
          <h3>{{Makers}}</h3>

          <p>Total Makers</p>
        </div>
        <div class="icon">
          <i class="ion ion-bag"></i>
        </div>
        <!-- <a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a> -->
      </div>
    </div>
    <div class="col-lg-3 col-xs-6">
      <!-- small box -->
      <div class="small-box bg-aqua">
        <div class="inner">
          <h3>{{Types}}</h3>

          <p>Total Types</p>
        </div>
        <div class="icon">
          <i class="ion ion-bag"></i>
        </div>
        <!-- <a href="#" class="small-box-footer">More info <i class="fa fa-arrow-circle-right"></i></a> -->
      </div>
    </div>

    <!-- ./col -->
  </div>

  <!-- <div class="col-lg-6">
    <div class="box box-info col-lg-6">
      <div class="box-header">
        <i class="fa fa-users"></i>

        <div>
          <p v-for="item in posts">
            {{item.title}}
          </p>
        </div>

        <h3 class="box-title">Quick User Add</h3>
        <!-- tools box -->
  <!-- <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-remove"></i></button>
        </div> -->
  <!-- /. tools -->
  <!-- </div>
      <div class="box-body col-lg-12">
        <div class="form-group">
          <label for="">User Id</label>
          <input type="text" name="" class="form-control" value="">
        </div>
        <div class="form-group">
          <label for="exampleInputEmail1">Password</label>
          <input type="text" class="form-control" placeholder="Enter Question">
        </div>
        <div class="form-group">
          <label>Template</label>
          <select class="form-control">
            <option>Catering</option>
            <option>Events</option>
            <option>Function</option>
          </select>
        </div>
        <button type="submit" class="btn btn-primary">Submit</button>
      </div> -->

  </div>
  </div>

  <!--- quick add template  -->
  <!-- <div class="col-lg-6">
    <div class="box box-info col-lg-6">
      <div class="box-header with-border">
        <h3 class="box-title color">Latest Feedbacks</h3>

        <div class="box-tools pull-right">
          <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
          </button>
          <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
        </div>
      </div>
      <div class="box-body">
        <div class="table-responsive">
          <table class="table no-margin">
            <thead>
              <tr>
                <th>Name</th>
                <th>Mobile</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><a href="#">kapil</a></td>
                <td>Catering</td>
                <td>Food..?</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div> -->

  <!-- /.row -->

  <!-- Main row -->
  <!-- /.row -->
</section>
<!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import axios from 'axios';

import {
  globalStore
} from '../../main.js';

export default {
  data() {
    return {
      FilesCount: 0,
      token: JSON.parse(localStorage.getItem("token")),
      Cars: 0,
      Types: 0,
      Makers: 0,
    }
  },
  mounted() {
    this.getAllCars()
    this.getAllMakers()
    this.getAllCarTypes()
  },
  methods: {
    getAllCars() {
      axios
        .get(globalStore.url + `product/getAllCars`, this.token)
        .then((res) => {
          console.log("all Makers", res.data.data);
          this.Cars = res.data.data.length;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    getAllMakers() {
      axios
        .get(globalStore.url + `product/getCompanies`, this.token)
        .then((res) => {
          console.log("all Makers", res.data.data);
          this.Makers = res.data.data.length;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
    getAllCarTypes() {
      axios
        .get(globalStore.url + `product/getCarTypes`, this.token)
        .then((res) => {
          this.Types = res.data.data.length;
        })
        .catch((e) => {
          console.log("error getting all files", e);
        });
    },
  }
}
</script>
<style>
.color {
  color: black
}

.info-box {
  cursor: pointer;
}

.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}

.fullCanvas {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?d806437e